import hook from '../../scripts/utilities/hook';

const BILLING_CYCLE_SELECTOR = hook('js-billing-cycle');
const PRICES_SELECTOR = hook('js-billing-cycle-price');
const BUTTON_SELECTOR = hook('js-billing-cycle-button');
const BACKGROUND_SELECTOR = hook('js-billing-cycle-background');

const HIDDEN_CLASS = 'u-display-none';
const ACTIVE_BUTTON_INDEX = 1;
const ACTIVE_CLASS = 'is-active';

class BILLING_CYCLE {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }

    this.element = element;

    this.initSelector();
    this.initListeners();
  }

  initSelector() {
    this.buttons = this.element.querySelectorAll(BUTTON_SELECTOR);
    this.background = this.element.querySelector(BACKGROUND_SELECTOR);
    this.prices = document.querySelectorAll(PRICES_SELECTOR);

    this.setBackgroundPosition(this.buttons[ACTIVE_BUTTON_INDEX]);
  }

  initListeners() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        this.toggleCycle(button);
      });
    });
  }

  setBackgroundPosition(activeButton) {
    const bodyRect = document.body.getBoundingClientRect();
    const activeButtonRect = activeButton.getBoundingClientRect();

    const activeButtonProps = {
      width: activeButtonRect.width,
      height: activeButtonRect.height,
      top: activeButtonRect.top - bodyRect.top,
      left: activeButtonRect.left + bodyRect.left,
    };

    this.background.style.width = `${activeButtonProps.width}px`;
    this.background.style.height = `${activeButtonProps.height}px`;
    this.background.style.transform = `translate(${activeButtonProps.left}px, ${activeButtonProps.top}px)`;
  }

  toggleCycle(activeButton) {
    if (activeButton.classList.contains(ACTIVE_CLASS)) {
      return;
    }

    this.setBackgroundPosition(activeButton);

    this.buttons.forEach(button => {
      button.classList.toggle(ACTIVE_CLASS);
    });

    this.prices.forEach(price => {
      price.classList.toggle(HIDDEN_CLASS);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(BILLING_CYCLE_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new BILLING_CYCLE(element);
  });
});
